'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT = exports.DEFAULT = 'DEFAULT';
var DOMAIN = exports.DOMAIN = 'DOMAIN';
var EMAIL = exports.EMAIL = 'EMAIL';
var QUEUED = exports.QUEUED = 'QUEUED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/constants/AvatarResponseTypes.js
// module id = 231
// module chunks = 0 1